module.exports = __webpack_public_path__ + "static/media/MEDIUM.b3668952.png";